import Button from "../Button/Button";

interface ITileProps {
  src?: string,
  alt?: string
  title: string,
  content?: any,
  classname?: string,
  btnLabel?: string,
  btnClass?: string,
  contentClass?:string,
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const Tile: React.FC<ITileProps> = ({
  src = '',
  alt = '',
  title = '',
  content = '',
  classname = '',
  btnLabel = "",
  contentClass="",
  btnClass="button",
  onClick
}) => {
  return (
    <div className={`image-container bg-midnight ${classname}`}>
      {
        src && <img
          src={src}
          alt={alt}
          className="image-style"
        />
      }
      <div
        className="d-flex flex-column justify-content-center align-items-center align-self-stretch"
      >
        <div
          className="w-100 d-flex flex-column justify-content-between h-100 data"
        >
          <div className="d-block">
            <h3 className="heading">{title}</h3>
            <p className={`content ${contentClass}`}>{content}</p>
          </div>
          <div className="w-100">
            <Button
              variant="dark"
              className={btnClass}
              label={btnLabel ? `${btnLabel}` : <>Take Action <i className="fa-solid fa-arrow-right"></i></>}
              onClick={onClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};